import type { EventScheduledEvent } from 'react-calendly';

import type { SortDirection } from '../../common/types/Common';

export { type GuidanceSession, GuidanceSessionType } from '@fruitful/types';

export enum GuidanceSessionSortField {
    START_TIME = 'startTime',
}

export interface SearchGuidanceSessionRequest {
    userId: string;
    membershipId: string;
    state: ScheduledEventStartState;
    limit?: number;
    offset?: number;
    sortField?: GuidanceSessionSortField;
    sortDirection?: SortDirection;
}

export enum ScheduledEventStartState {
    UPCOMING = 'upcoming',
    PAST = 'past',
}

export enum UpcomingSessionCardContext {
    MY_GUIDE = 'my_guide',
    GOALS = 'goals',
    HOME = 'home',
}

export const DEFAULT_SESSION_TIME_ZONE = 'America/New_York';
export const DEFAULT_SESSION_TIME_ZONE_LABEL = 'Eastern Time';

export interface InlineCalendlyWidgetProps {
    calendlyUrl: string;
    onEventScheduled?: (event: EventScheduledEvent) => void;
    containerHeight?: number;
}
